module.exports = __webpack_public_path__ + "img/nodata_fianza.522f1f96.svg";